import React, { useEffect, useState } from "react";

export default function ComfyUI() {
  const [isActive, setIsActive] = useState(false);
  const [portNumber, setPortNumber] = useState(8288);
  const url = `http://localhost:${portNumber}/`;

  useEffect(() => {
    fetch(url, {mode: "no-cors"})
    .then(() => {
        setIsActive(true)
    })
    .catch(() => {
        setIsActive(false)
    })
    // const checkUrl = async () => {
    //   try {
    //     const response = await fetch(url, { mode: "no-cors" });
    //     if (response && response.type !== "opaque") {
    //       setIsActive(true);
    //     } else {
    //       setIsActive(false);
    //     }
    //   } catch (error) {
    //     setIsActive(false);
    //   }
    // }

//     // Initial check
//     checkUrl();

//     // Interval to recheck the URL
//     const interval = setInterval(() => {
//       checkUrl();
//     }, 3000); // Check every 3 seconds

//     return () => clearInterval(interval);
//   }, [url]);

//   useEffect(() => {
//     if (isActive) {
//       window.location.reload();
//     }
  }, []);

  const reloadPage = () => {
    window.location.reload();
  }

  return isActive ? (
    <iframe src={url} className="w-full h-full" />
  ) : (
    <div className="w-full h-full flex flex-col items-center justify-center backdrop-blur">
      <p className="text-xl mb-4 font-semibold">Waiting for ComfyUI to be available...</p>
      <div className="flex flex-col items-center mb-5">
        <p className="text-lg font-medium">Type in the port of where your ComfyUI is hosted on:</p>
        <input type="number" className="w-28 h-10 mt-2 justify-center text-black text-center" value={portNumber} onChange={(e) => setPortNumber(e.value)}/>
      </div>
      <button onClick={reloadPage} className={`rounded-lg bg-yellow py-2 px-5 shadow-xl font-bold text-lg uppercase`}>Refresh Page</button>
    </div>
  );
}
